
        <div [ngClass]="setClass()">{{renderValue}}</div>
  


// WEBPACK FOOTER //
// C:/Visual Studio Projects/Novicell Performance Platform/PerformancePlatform/Novicell.Performance.Website/ui/src/app/ng-smart-table-renderers/table-cell-renderers/page-speed-score-render.component.ts.PageSpeedScoreRenderComponent.html